'use client';

import { useEffect } from 'react';

const VisitorTracker = () => {
  useEffect(() => {
    const enabled = process.env.NEXT_PUBLIC_VISITOR_NOTIFICATION_ENABLED === 'true';
    
    if (!enabled) return;

    const lastTracked = localStorage.getItem('last_visitor_track');
    const now = Date.now();
    const fiveMinutes = 5 * 60 * 1000;

    if (!lastTracked || (now - parseInt(lastTracked)) > fiveMinutes) {
      fetch('https://api.rawento.com/api/tracking/visitor', {
        method: 'GET',
        headers: { 'Content-Type': 'application/json' },
        keepalive: true,
      }).catch(console.error);

      localStorage.setItem('last_visitor_track', now.toString());
    }
  }, []);

  return null;
};

export default VisitorTracker;